import React, { useEffect, useRef, useState } from 'react'

// UTILS
import { thousandSeparator } from '../../utils/helpers'

const CommissionTable = (props) => {
    const entity = props.entity?.agents ?? props.entity
    const tableRef = useRef(null)
    const [showSubsale, setShowSubsale] = useState(false)
    const [showProject, setShowProject] = useState(false)

    const handleClickName = (item) => {
        if (props?.handleClick) props.handleClick(item)
    }

    // SCROLL TO FIRST
    useEffect(() => {
        if (tableRef.current) {
            tableRef.current.scrollTo({
                top: 0,
                behavior: "instant",
            }); 
        }
    }, [entity])

    return (
        <div className='flex flex-col h-full w-full rounded-[10px] bg-white shadow-md py-2 px-4'>
            <div className='mb-1.5 flex items-center justify-between'>
                <p className='font-semibold text-gray-one uppercase'>{ props?.title }</p>

                <div className='flex items-center gap-4'>
                    <div className='flex items-center gap-1.5'>
                        <span onClick={ () => setShowSubsale(!showSubsale) } className='flex-shrink-0 h-2 w-2 rounded-full bg-primary cursor-pointer hover:scale-125 transition'></span>
                        <p className='text-xs text-gray-two'>Subsale</p>
                    </div>

                    <div className='flex items-center gap-1.5'>
                        <span onClick={ () => setShowProject(!showProject) } className='flex-shrink-0 h-2 w-2 rounded-full bg-orange cursor-pointer hover:scale-125 transition'></span>
                        <p className='text-xs text-gray-two'>Project</p>
                    </div>
                </div>
            </div>

            <div className='border-border border-t flex-1 relative'>
                <div ref={ tableRef } className='absolute top-0 left-0 w-full h-full overflow-scroll bg-white'>
                    <div className="md:w-full w-[1080px] h-full">
                        {
                            entity?.length > 0 ?
                            entity.map((item, idx) => {
                                return <div key={ idx } className='border-border border-b w-full text-gray-two group flex justify-between hover:bg-primary-light hover:bg-opacity-25 transition duration-300'>
                                    <div className="flex-[2] flex-shrink-0 text-xs font-bold py-2 whitespace-nowrap text-start">
                                        <span onClick={ () => handleClickName((item.id || item._id) ? item : item.branch) } className='cursor-pointer transition duration-300 hover:text-primary'>
                                            { item.name ?? item.branch }
                                        </span>
                                    </div>

                                    {
                                        (item.name && item.branch) &&
                                        <>
                                            <div className="flex-1 text-xs font-light py-2 whitespace-nowrap text-center">
                                                { item.branch }
                                            </div>

                                            {
                                                item.group &&
                                                <div className="flex-1 text-xs font-light py-2 whitespace-nowrap text-center">
                                                    { item.group }
                                                </div>
                                            }
                                        </>
                                    }

                                    <div className={ "flex-1 text-xs font-medium py-2 whitespace-nowrap text-end transition duration-300 text-primary" }>
                                        RM { thousandSeparator(item?.subsale) }
                                    </div>

                                    <div className={ "flex-1 text-xs font-medium py-2 whitespace-nowrap text-end transition duration-300 text-orange" }>
                                        RM { thousandSeparator(item?.project) }
                                    </div>

                                    <div className="flex-1 text-xs font-medium py-2 whitespace-nowrap text-end">
                                        RM { thousandSeparator(item?.totalCommission) }
                                    </div>
                                </div>
                            }) :
                            <div className='text-gray-two h-full flex justify-center items-center'>
                                <div colSpan='100%' className="flex-1 text-xs font-light px-3 py-4 whitespace-nowrap text-center">There is no data</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CommissionTable